import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  position: relative;

  .similar-content-section {
    &__powered-by {
      margin-top: 20px;

      display: flex;
      align-items: center;
      justify-content: flex-end;

      ${breakpoints.down('xs')} {
        width: 100%;
        justify-content: center;

        img {
          max-width: 125px;
        }
      }

      p {
        margin-right: 8px;
      }
    }
  }
`;

export default Wrapper;
